// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"b6a09e6f","448":"44f1f288","631":"ef533760"}[chunkId] + ".chunk.css";
};